import { gql } from '@apollo/client';

export const CANCEL_PRINT_CHECKS = gql`
  mutation CancelPrintChecks($checkNumber: Int!) {
    cancelPrintChecks(cancelPrintChecksInput: { checkNumber: $checkNumber }) {
      success
    }
  }
`;
